export const HS_TRAINING_URL = 'product/high-school/training'
